import React from 'react';
import Input from 'components/Input/Input';

const DownshiftInput = React.forwardRef((props, ref) => (
  <Input innerRef={ref} {...props} />
));

export default DownshiftInput;
